function eventHasDates (ev) {
  return !!(ev && ev.start_date && ev.end_date)
}

export function guardSchedulerRender (scheduler) {
  if (!scheduler || scheduler._johkuRenderGuarded) {
    return
  }
  if (typeof scheduler.updateEvent !== 'function') {
    return
  }
  scheduler._johkuRenderGuarded = true
  const origUpdateEvent = scheduler.updateEvent.bind(scheduler)
  scheduler.updateEvent = function (id) {
    const ev = typeof this.getEvent === 'function' ? this.getEvent(id) : null
    if (!eventHasDates(ev)) {
      return
    }
    try {
      return origUpdateEvent(id)
    } catch (e) {
      if (e && typeof e.message === 'string' && e.message.indexOf('start_date') !== -1) {
        return
      }
      throw e
    }
  }
  if (typeof scheduler.render_view_data === 'function') {
    const origRender = scheduler.render_view_data.bind(scheduler)
    scheduler.render_view_data = function (evs, hold) {
      if (Array.isArray(evs)) {
        evs = evs.filter(eventHasDates)
        if (!evs.length) {
          return
        }
        try {
          return origRender(evs, hold)
        } catch (e) {
          if (e && typeof e.message === 'string' && e.message.indexOf('start_date') !== -1) {
            return
          }
          throw e
        }
      }
      try {
        return origRender.apply(this, arguments)
      } catch (e) {
        if (e && typeof e.message === 'string' && e.message.indexOf('start_date') !== -1) {
          return
        }
        throw e
      }
    }
  }
}

export function schedulerEventHasDates (ev) {
  return eventHasDates(ev)
}
